/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';

import Field from 'zignal-landscape/lib/Field';
import Radio from 'zignal-landscape/lib/Radio';
import Label from 'zignal-landscape/lib/Label';

const style = {
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  padding: 20
};

const paths = [1,2,3];

const PathSelectionPage = ({ wizardStore, onChange }) => {
  const { selectedRadio } = wizardStore;
  return (
    <div style={style}>
      <h3>Choose your path</h3>
      <div>
        <Field>
          { paths.map((path) => (
            <div key={path}>
              <Radio
                id={`path${path}`}
                name="path"
                checked={selectedRadio === path}
                onChange={() => onChange(path)}
              />
              <Label htmlFor={`path${path}`} inline>Path {path}</Label>
            </div>
          ))}
        </Field>
      </div>
    </div>
  );
};

PathSelectionPage.propTypes = {
  wizardStore: PropTypes.object,
  onChange: PropTypes.func,
};

export default PathSelectionPage;
